import React from 'react';
import Button from '../button';
import { FaCheckCircle } from 'react-icons/fa';
import { X } from 'lucide-react';

type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  btnText: any;
  content: React.ReactNode;
  onConfirm?: () => void;
};

const SchoolFeesPreviewModal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  title,
  content,
  btnText,
  onConfirm,
  ...rest
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[99] flex items-center justify-center w-full h-full overflow-y-auto bg-gray-500 bg-opacity-50">
      <div className="relative p-4 w-full max-w-3xl bg-white h-[90%] max-h-[650px] scrollbar-always-visible rounded-lg shadow-lg">
        <button
          type="button"
          className="absolute top-3 right-3 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 flex justify-center items-center"
          onClick={onClose}
        >
          <X />
        </button>
        <div className="p-4 text-center">
          <FaCheckCircle className="text-center mx-auto w-20 h-40 text-gray-4" />
          <h3 className="mb-5 text-lg font-bold ">{title}</h3>
          <div className="mb-4">{content}</div>
          <div className="flex justify-center gap-4">
            <Button type="button" onClick={onClose} className="mt-6 w-full">
              Cancel
            </Button>
            <Button type="button" onClick={onConfirm} className="mt-6 w-full">
              {btnText}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SchoolFeesPreviewModal;
